export default "__VITE_ASSET__D$XUGTzP__"